module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Keyboard-and-mouse.aaf77661.jpg";